$(document).on("click", ".question_product,.custom_icons_faq_main .icons_with_text_item_title", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.custom_icons_faq_main .icons_with_text_item_title').removeClass('active');
    jQuery('.question_product,.custom_icons_faq_main .icons_with_text_item_title').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", ".faq_question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.faq_question').removeClass('active');
    jQuery('.faq_question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});
$(document).on("click", ".faq_question_new_main", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).find('.faq_question_text').toggleClass('active');
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.faq_question_new_main').removeClass('active');
    jQuery('.faq_question_text').removeClass('active');
    jQuery('.faq_question_new_main').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).find('.faq_question_text').toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});




 $(document).on("click", ".custom_button", function (e) {
     var video = jQuery(this).parents('.video_wrapper_custom').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
     jQuery(this).addClass('active');
 }
 });








$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#faqs']", function (e) {
  e.preventDefault();
  document.querySelector('#faqs').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#result']", function (e) {
  e.preventDefault();
  document.querySelector('#results').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#results']", function (e) {
  e.preventDefault();
  document.querySelector('#results').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#portfolio']", function (e) {
  e.preventDefault();
  document.querySelector('#portfolio').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#services']", function (e) {
  e.preventDefault();
  document.querySelector('#services').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#careers']", function (e) {
  e.preventDefault();
  document.querySelector('#careers').scrollIntoView({
    behavior: 'smooth'
  })
});



jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

function isAtViewportMidline(el) {
  if (!el || !el.getBoundingClientRect) return false;
  if (!$(el).is(':visible')) return false;

  const rect = el.getBoundingClientRect();
  const vw = window.innerWidth || document.documentElement.clientWidth;
  const vh = window.innerHeight || document.documentElement.clientHeight;
  const midY = vh / 2;

  // horizontally on-screen AND the element spans the middle line
  return rect.left < vw && rect.right > 0 && rect.top < midY && rect.bottom > midY;
}

function runCounters($block) {
  $block.addClass('start_count');
  $block.find('.count_js').each(function () {
    const $c = $(this);
    const target = +($c.data('value') || 0);
    $c.prop('Counter', 0).stop(true).animate(
      { Counter: target },
      {
        duration: 2000,
        easing: 'swing',
        step: function (now) { $c.text(Math.ceil(now)); }
      }
    );
  });
}

function checkCountersInView() {
  $('.custom_counter .icons_with_text_flex').each(function () {
    const $block = $(this);
    if ($block.hasClass('start_count')) return;          // only once
    if (isAtViewportMidline(this)) runCounters($block); // trigger when truly visible
  });
}

$(window).on('scroll load', checkCountersInView);




$(document).on("click", ".tab_item_pdp", function (e) {
var data_tab = $(this).attr('data_tab');
$('.tab_item_pdp').removeClass('active');
$(this).addClass('active');
$('.tab_content_pdp').hide();
$('.tab_content_pdp[data_tab="'+data_tab+'"]').show();
});


$(document).on("click", '.product_slider_custom_slider_button a.custom_hk_button, .ajax_add_cart ', function(e) {
 e.preventDefault(); 
var this_element =  jQuery(this);
this_element.addClass('loading_hk');
var id = jQuery(this).attr('variant_id');
jQuery.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: id
},
  dataType: 'json', 
 success: function (data) { 
    $.get(window.location.pathname, function (res) {
      var $new = $(res).find('#cart_drawer_content');
      $('#cart_drawer_content').replaceWith($new);
         // Update cart count
      const $newCartCount = $(res).find('.cart_count_js');
      const cartCount = parseInt($newCartCount.text().trim(), 10);
      
      if (cartCount > 0) {
        $('.cart_count_js').text(cartCount).show();
      } else {
        $('.cart_count_js').text('').hide();
      }
      $('#cart-drawer').removeClass('is_empty').addClass('open');
      $('.custom_overlay2').addClass('active');
      this_element.removeClass('loading_hk');
    });
 } 
 });
  });



   $(window).scroll(function(){
      if ($(this).scrollTop() > 30) {
         $('body').addClass('remove_transparent');
      } else {
         $('body').removeClass('remove_transparent');
      }
  });


  function isScrolledIntoView2(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
docViewBottom = docViewBottom-($(window).height()/2)+($(elem).height())+100;
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom));
}

$(window).scroll(function () {
    $('.pdp_skin_list1 .icons_with_text_flex .icons_with_text_item').each(function () {
        if (isScrolledIntoView2(this) === true) {
            $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
    });
});


















function initSeenSlider() {
  var $slider = $('.el-hp-seen-list1 .icons_with_text_flex');
    $slider.slick({
      dots: false,
      arrows: false,
      speed: 9000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 1,
      infinite: true,
      draggable: false,
      swipeToSlide: false,
      touchMove: false,
      variableWidth: true,
      cssEase: 'linear'
    });
}

// Run on document ready
$(document).ready(function () {
  initSeenSlider();
});

// Run on window load
$(window).on('load', function () {
  initSeenSlider();
});

// Run on resize (debounced for performance)
var resizeTimer;
$(window).on('resize', function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    initSeenSlider();
  }, 250);
});


$(document).on("click", ".el-hp-footer-menu p", function () {
  var $this = $(this);
  var $next = $this.next();

  if ($this.hasClass("active")) {
    $this.removeClass("active");
    $next.slideUp();
  } else {
    $('.el-hp-footer-menu p').removeClass('active');
    $('.el-hp-footer-menu p').next().slideUp();

    $this.addClass("active");

    $next
      .css('display', 'flex') // force flex
      .hide()
      .slideDown();
  }
});


/*
$(document).on('click', '.el-hp-product .review_richtext_slider_new a', function (e) {
  e.preventDefault();

  var $link = $(this);
  var variantId = $link.attr('variant_id') || $link.data('variant_id');
  var redirectUrl = $link.attr('href');

  if (!variantId) {
    console.error('Variant ID not found');
    window.location.href = redirectUrl; // fallback
    return;
  }

  // Optional: prevent double clicks
  if ($link.hasClass('loading_hk')) return;
  $link.addClass('loading_hk');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({
      id: parseInt(variantId),
      quantity: 1
    }),
    contentType: 'application/json',
    dataType: 'json',

    success: function () {
      window.location.href = '/cart';
    },

    error: function (err) {
      console.error('ATC failed', err);
      window.location.href = redirectUrl; // fallback anyway
    },

    complete: function () {
      $link.removeClass('loading_hk');
    }
  });
});*/